import { Injectable } from '@angular/core';
import { BaseOptionService } from '@luzula/luzula-lib';

@Injectable({
	providedIn: 'root'
})
export class OptionService extends BaseOptionService {
	private humusFormRegExp = "^((([sfimnt])(b[1-8])?(Hu|Ma|Ro|RM|Mo|MM|Mu|aÖ|zÖ|mÖ|kÖ|rÖ))|(NH|OH|UH))$";
  private FBFprefixRegExp = "^(?:b|g|h|o|p|q|s|Ap|po|rb|tp|w|a|x)*$";
  private farbeRegExp = "^(rostf|ock|sch|bg|br|ro|fa|gl|gr|gn|h|d|w)*$";

  constructor() {
		super();
    // Options: sollen die html-templates der View- und Input-Elemente vereinfachen
		
		// Maskierte Felder: 
		//this.registerOption("Kartierer", { masked: true });
		
    // <bp-list...>
    this.registerOption("Koordinatensystem", { tableName: "Koordinatensysteme" });
		this.registerOption("Punktart", { tableName: "Punktarten" }); 
    this.registerOption("PunktartMitProtokoll", { tableName: "Punktarten" });
    this.registerOption("Unterabteilung", { options: "a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z" });
    this.registerOption("Entwässerungsverhalten", { options: "I|II|III" });
    this.registerOption("Substrat", { tableName: "Bodenarten", placement: "right-top" });
    this.registerOption("Horizont1", { tableName: "HorizontSymbole" });
    this.registerOption("Horizont2", { tableName: "HorizontSymbole" });
    this.registerOption("Horizont3", { tableName: "HorizontSymbole" });
    this.registerOption("Humusgehalt", { options: "|0|1|2|3|4|5|6|7" });
    this.registerOption("Lagerungsdichte", { options: "|1|2|3" });
    this.registerOption("Skelettgehalt", { options: "|0|1|2|3|4|5|6|7" });
    this.registerOption("Karbonat", { options: "|0|1|2|3|4|5|6" });
    this.registerOption("PHOrt", { options: "|Oberboden|Saugsaum" });
    this.registerOption("Mesoklima", { options: "|fr|tr" });
    this.registerOption("GeologieTrenner", { options: "|/|//" });
    this.registerOption("Mesoklima", { options: "|fr|tr" });
    this.registerOption("KlimastufeAlt", { tableName: "Klimastufen", acceptOtherValues: true });
    this.registerOption("KlimastufeNeu", { tableName: "Klimastufen", acceptOtherValues: true });
    this.registerOption("Vegetation", { tableName: "Bodenvegetationen", expandOnClick: false, maxItems: 20 });
    this.registerOption("Vegetationsschicht", { options: "|b1|b2|str|kr1|kr2|m" });
    this.registerOption("Ökologischer Moortyp", { options: "|SA - Sauer-Armmoor|SZ - Sauer-Zwischenmoor|BZ - Basenzwischenmoor|KZ - Kalk-Zwischenmoor|RM - Reichmoor" });
    this.registerOption("Hydrogenetischer Moortyp", { options: "|Verlandungsmoor|Versumpfungsmoor|Kesselmoor|Durchströmungsmoor|Quellmoor|Hangmoor|Hangquellmoor|Überflutungsmoor|Regenmoor" });
		this.registerOption("Nährkraftstufe", { tableName: "Nährkraftstufen" } );
		this.registerOption("Stammfeuchtestufe1", { options: "|O|N|Ü|W" } );
		this.registerOption("Stammfeuchtestufe2", { options: "|3|3w|2|2g|2w|1|1w|0|4|4w|3ü|4ü" } );
		this.registerOption("Substratgruppe", { tableName: "Substrattypengruppen", acceptOtherValues: true } );
		this.registerOption("KMgCaP-Serie", { from: "dietmarsMdb", tableName: "zcd_Serie", tableColumn: "Serie_k" } );
		this.registerOption("V-Wert-Vermutet", { options: "|<15|15-40|>40" } );
		this.registerOption("Torf-Zersetzungsgrad", { options: "|1|2|3|4|5|6|7|8|9|10" } );
		this.registerOption("Mudde-Konsistenz", { options: "|1|2|3|4|5" } );
		this.registerOption("Substanzvolumen", { options: "|1|2|3|4|5" } );
		this.registerOption("Reliefform Bestand", { options: "|rasig|bültig" } );
		this.registerOption("Reliefform Bodenvegetation", { options: "|rasig|bültig" } );

		// Relief-Erweiterung nach SEA
		this.registerOption("Neigungsstufe", { tableName: "Neigungsstufe", tableColumn: "id", displayColumn: "label" } );
		this.registerOption("Woelbung", { tableName: "Woelbung", tableColumn: "id", displayColumn: "label" } );
		this.registerOption("Hangrichtung", { tableName: "Hangrichtung", tableColumn: "id", displayColumn: "label" } );
		this.registerOption("Hanganschluss", { tableName: "Hanganschluss", tableColumn: "id", displayColumn: "label" } );
		this.registerOption("Hangteil", { tableName: "Hangteil" } );
		this.registerOption("InnereRauhheit", { tableName: "InnereRauhheit", tableColumn: "id", displayColumn: "label" } );

		this.registerOption("pH", { min: 0, max: 14 });

    // nonEmpty
    const nonEmptyFields = new Array<string>(...[
      "Punktart", "Forstamt", "Aufnahmedatum", "Kartierer", "Nummer", "Feinbodenform", "Entwässerungsverhalten",
      "X-Koordinate", "Y-Koordinate"
    ]);
    this.registerOptionFor(nonEmptyFields, { nonEmpty: true });

    // typeaheads
    this.registerOption("Forstamt", { tableName: "Forstämter" });
    this.registerOption("Revier", { tableName: "Reviere", tableColumn: "FORSTREVIE" });
    this.registerOption("Hauptbodenform", { tableName: "Feinbodenformen", tableColumn: "HBF" });
    this.registerOption("Feinbodenform", { tableName: "Feinbodenformen", tableColumn: "FBF", maxItems: 50 });
    this.registerOption("BodenformSuffix", { tableName: "BodenformSuffixe", tableColumn: "value" });
    this.registerOption("Reliefform", { from: "dietmarsMdb", tableName: "zda_RelFo", tableColumn: "RelFo_t", acceptOtherValues: true });
    this.registerOption("ReliefformUmgebung", { tableName: "ReliefformUmgebung" });
    this.registerOption("GeologieOben", { from: "dietmarsMdb", tableName: "zca_GeEinh", tableColumn: "GeEinh_p" });
    this.registerOption("GeologieUnten", { from: "dietmarsMdb", tableName: "zca_GeEinh", tableColumn: "GeEinh_p" });
    this.registerOption("Morphologie0", {  from: "dietmarsMdb", tableName: "zcb_GeMor", tableColumn: "GeMor_t" });
    this.registerOption("Morphologie1", {  from: "dietmarsMdb", tableName: "zcb_GeMor", tableColumn: "GeMor_t" });
    this.registerOption("HumusformAlt", { tableName: "Humusformen" });
    this.registerOption("HumusformNeu", { tableName: "Humusformen" });
    this.registerOption("Vegetationsformengruppe", { tableName: "Humusformen" });
    this.registerOption("Qualitätsstufe", { tableName: "Qualitätsstufen", tableColumn: "id", displayColumn: "name" });
		this.registerOption("Torfart1", { tableName: "Torfarten", tableColumn: "value" } );
		this.registerOption("Torfart2", { tableName: "Torfarten", tableColumn: "value" } );
		this.registerOption("Torfart3", { tableName: "Torfarten", tableColumn: "value" } );
		this.registerOption("Wuchsgebiet", { tableName: "Wuchsgebiete" } );
		this.registerOption("Wuchsbezirk", { tableName: "Wuchsbezirke", tableColumn: "WB" } );
		
		// this.registerOption("Bestandsbeschreibung", { tableName: "Bestandsbeschreibungen", tableColumn: "ID" } );

    // regular expressions
    this.registerOption("HumusformNeu", { regex: this.humusFormRegExp, regexFailMessage: this.humusFormRegexpMessage });
    this.registerOption("FBFPrefix", { regex: this.FBFprefixRegExp, regexFailMessage: this.fbfPrefixRegexpMessage });
    this.registerOption("Farbe", { regex: this.farbeRegExp, regexFailMessage: this.farbeRegexpMessage });
  
    // acceptOtherValues
    const acceptOtherValuesFieldFields = new Array<string>(...[
      "Revier", "HumusformAlt", "HumusformNeu"
    ]);
    this.registerOptionFor(acceptOtherValuesFieldFields, { acceptOtherValues: true });

    // cm
    const cmFields = new Array<string>(...[
      "Tiefe", "Moormächtigkeit",
      "Go", "Gr", "G", "Sw", "Sd", "S",
    ]);
    this.registerOptionFor(cmFields, { unit: "cm" });

    // %
    const percFields = new Array<string>(...[
      "Schichtanteilb1", "Schichtanteilb2", "Schichtanteilstr", "Schichtanteilkr1", "Schichtanteilkr2", "Schichtanteilm",
    ]);
    this.registerOptionFor(percFields, { unit: "%", min: 0, max: 100 });
  }

  // Regex-Message Funktionen für Bohrpunkte-spezifische Validierungen
  humusFormRegexpMessage(str: string, regex: string): string {
    const matches = str.match(regex);
    if (matches) return "";
    else {
      return "Wert muss mit s,f,i,m,n,t starten, gefolgt von optionalem b1-b8 und mit Hu,Ma,Ro,RM,Mo,MM,Mu,aÖ,zÖ,mÖ,kÖ,rÖ enden. Alternativ eins von NH,OH,UH.";
    }
  }

  fbfPrefixRegexpMessage(str: string, regex: string): string {
    const matches = str.match(regex);
    if (matches) return "";
    else {
      return "Wert muss eine Aufeinanderfolge von b,g,h,o,p,q,s,Ap,po,rb,tp sein.";
    }
  }


  farbeRegexpMessage(str: string, regex: string): string {
    const matches = str.match(regex);
    if (matches) return "";
    else {
      return "Nur zulässige Kombinationen.";
    }
  }
}
